import React, { Component } from 'react';
import classes from "./Chart_Village_Species_Board.module.css";
import Chart_Village_Species_BarChart from './Chart_Village_Species_BarChart';

/* 
<p>Villagers belong to 30+ Species* in the Animal Kingdom. Because Animal Crossing Fandom is maintained by fans, inconsistencies in data (e.g. 0 Kangeroo Villager) is apparent. *Excludes Special villagers.</p>
*/

export default class Chart_Village_Species_Board extends Component {

    render() {
        return (
            <div classNane="wrapper-chart">
              <div className={classes.container}>
                <Chart_Village_Species_BarChart />
              </div>       
            </div>
        )
    }
}